const guidance = {
  "phoneNumber": {
    "ERR_MALFORMATTED": {
      "heading": "{%fieldName%} Format:",
      "format": "Phone number must be valid",
    },
    "ERR_TOO_SHORT": {
      "heading": "{%fieldName%} Format:",
      "format": "Must be a minimum of 10 digits",
    },
    "ERR_INVALID_AREA_CODE": {
      "heading": "{%fieldName%} Format:",
      "format": "Must be a valid phone number",
    },
    "ERR_INVALID_EXCHANGE": {
      "heading": "{%fieldName%} Format:",
      "format": "Must be a valid phone number",
    },
  },
  "password": {
    "ERR_MALFORMATTED": {
      "heading": "{%fieldName%} Format:",
      "format": "8 - 16 characters long, with least one<br/>of each: a-z, A-Z, 0-9, !@#$%^&*()",
    },
  },
  "emailAddress": {
    "ERR_MALFORMATTED": {
      "heading": "{%fieldName%}",
      "format": "Must be a valid E-mail address",
    },
  },
  "birthdate": {
    "ERR_MALFORMATTED": {
      "heading": "{%fieldName%} Format:",
      "format": "MM/DD/YYYY",
    },
  },
  "resetCode": {
    "ERR_MALFORMATTED": {
      "heading": "{%fieldName%} Format:",
      "format": "6 digits, matching code from E-mail",
    },
  },
};

export default guidance;
